export { default } from './NoticeEdit';

